import { ThemeProvider } from "@emotion/react";
import React, { createContext, useEffect, useState } from "react";
import { CstmMui } from "./utils";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./scss/App.scss";
import "./scss/JHProg.scss";
import { Auth, DashRoute, CLoader } from "./component";
import { connect } from "react-redux";
import * as actions from "./api/actions/pos";
import { controller, endpoints } from "./api/actions/api";
import { Loader } from "./controls";
import { IsEmptyObj } from "./hooks/Method";

export const AppContext = createContext({});

function App(props) {
  const { _get, _authUser } = props;
  const { theme } = CstmMui();
  const [loader, setLoader] = useState(false);
  const [cLoader, setCLoader] = useState(false);
     
    useEffect(() => {
      const hasAuthCookie = document.cookie
        ?.split("; ")
        ?.some(row => row.startsWith("pos_auth="));

      if (!hasAuthCookie) {
        setCLoader(false);
        return;
      }

      setCLoader(true);
      const onComplete = () => setCLoader(false);

      _get(
        endpoints.Auth + controller.GetAuthUser,
        actions.ActionType.Auth,
        onComplete
      );

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  return (
    <ThemeProvider theme={theme}>
      <AppContext.Provider value={{ loader, setLoader, cLoader, setCLoader }}>
        <Loader show={loader} />
        <CLoader show={cLoader} />
        <Router>
          <Routes>
            <Route
              path="/*"
              element={!IsEmptyObj(_authUser) ? <DashRoute /> : <Auth />}
            />
          </Routes>
        </Router>
      </AppContext.Provider>
    </ThemeProvider>
  );
}

const mapStateToProps = (state) => ({
  _authUser: state.pos.authUser,
});

const mapActiontoProps = {
  _get: actions.get,
};

export default connect(mapStateToProps, mapActiontoProps)(App);
